// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   USAGE SECTION — Settings page integration
   Matches account-field pattern from Settings.css
   ============================================ */

.usage-section {
  display: flex;
  flex-direction: column;
}

/* Row: label left, value right — matches account-field */
.usage-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-1) 0;
}

.usage-row + .usage-progress-track {
  margin-top: var(--space-2);
}

.usage-row-label {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
  font-weight: var(--font-weight-semibold);
}

.usage-row-value {
  font-size: var(--text-base);
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
}

.usage-row-value.warning {
  color: #f59e0b;
}

.usage-row-value.at-limit {
  color: #ef4444;
}

.usage-unlimited-value {
  color: var(--color-success);
  font-weight: var(--font-weight-semibold);
}

/* Progress bar — thin, subtle */
.usage-progress-track {
  height: 4px;
  background: var(--border-subtle);
  border-radius: 2px;
  overflow: hidden;
}

.usage-progress-fill {
  height: 100%;
  background: var(--accent-primary);
  border-radius: 2px;
  transition: width 0.3s ease, background 0.3s ease;
}

.usage-progress-fill.warning {
  background: #f59e0b;
}

.usage-progress-fill.at-limit {
  background: #ef4444;
}

/* Reset hint */
.usage-reset-hint {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  margin-top: var(--space-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/UsageDashboard.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":["/* ============================================\n   USAGE SECTION — Settings page integration\n   Matches account-field pattern from Settings.css\n   ============================================ */\n\n.usage-section {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Row: label left, value right — matches account-field */\n.usage-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-1) 0;\n}\n\n.usage-row + .usage-progress-track {\n  margin-top: var(--space-2);\n}\n\n.usage-row-label {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n  font-weight: var(--font-weight-semibold);\n}\n\n.usage-row-value {\n  font-size: var(--text-base);\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-medium);\n}\n\n.usage-row-value.warning {\n  color: #f59e0b;\n}\n\n.usage-row-value.at-limit {\n  color: #ef4444;\n}\n\n.usage-unlimited-value {\n  color: var(--color-success);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* Progress bar — thin, subtle */\n.usage-progress-track {\n  height: 4px;\n  background: var(--border-subtle);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.usage-progress-fill {\n  height: 100%;\n  background: var(--accent-primary);\n  border-radius: 2px;\n  transition: width 0.3s ease, background 0.3s ease;\n}\n\n.usage-progress-fill.warning {\n  background: #f59e0b;\n}\n\n.usage-progress-fill.at-limit {\n  background: #ef4444;\n}\n\n/* Reset hint */\n.usage-reset-hint {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  margin-top: var(--space-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
